import styles from './ProjectCard.module.css';
import { getAuthContext } from '../../context/AuthContext';
import Button from '../Button/Button';
import FormModal from '../FormModal/FormModal';
import { Trash2 } from 'lucide-react';
import type { Project } from '../../../shared/types';

interface ProjectCardProps {
  data: Project;
  onSucessfullSubmit: () => void;
}

const ProjectCard = ({ data, onSucessfullSubmit }: ProjectCardProps) => {
  const { session, user } = getAuthContext();

  const deleteProject = async () => {
    const id = data.id;
    try {
      const url = `${
        import.meta.env.VITE_BASE_URL || 'https://mellem.dev'
      }/api/v1/delete/project/${id}`;

      const options: RequestInit = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${session?.token_type} ${session?.access_token}`,
        },
      };
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error('Failed to delete project');
      }
      const result = await response.json();
      if (result.success) {
        onSucessfullSubmit();
      }
    } catch (error) {
      console.error('Error deleting project:', error);
    }
  };

  return (
    <div className={styles.projectCard}>
      <h3 className={styles.cardTitle}>{data.project_name}</h3>
      <div className={styles.imageContainer}>
        <a href={data.link} target="_blank" rel="noopener noreferrer">
          <img src={data.image} alt="Image of the current project" />
        </a>
      </div>
      <div className={styles.cardContent}>
        <div className={styles.cardHeader}>
          <p className={styles.description}>{data.project_description}</p>
        </div>
        <div className={styles.technologies}>
          {data.technologies.map((tech) => (
            <div className={styles.technology} key={tech}>
              <p>{tech}</p>
            </div>
          ))}
        </div>
      </div>
      {user && (
        <>
          <hr />
          <div className={styles.buttonContainer}>
            <FormModal onSucessfullSubmit={onSucessfullSubmit} data={data} mode="edit" />
            <Button className="deleteButton" onClick={deleteProject}>
              <Trash2 className={styles.deleteIcon} />
              Delete
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default ProjectCard;

